module.exports = __webpack_public_path__ + "img/OtherCourses.784e7b04.svg";